// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files
import translationEN from './locales/en/translation.json';
import translationGR from './locales/gr/translationgr.json';

const resources = {
  en: {
    translation: translationEN,
  },
  el: { // Ensure this key matches the key you're using to set Greek language
    translation: translationGR,
  },
};

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;
